import React, { useState } from "react";
import { Button, Menu, MenuItem, Box, Typography, Avatar } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import styles from "../../pages/app/Nurture/components/Nurture.module.css";
import highFlagIcon from "../FlagAssign/assets/High.svg";
import urgentFlagIcon from "../FlagAssign/assets/Urgent.svg";
import normalFlagIcon from "../FlagAssign/assets/Normal.svg";
import lowFlagIcon from "../FlagAssign/assets/Low.svg";
import defaultFlag from "../FlagAssign/assets/flag-default.svg";

const PillDropdown = ({
  value,
  options,
  backgroundColor,
  color,
  hoverBackgroundColor,
  isEmployee = false,
  isPriority = false,
  handleSelect,
  leadId,
  disabled,
}: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selected, setSelected] = useState("Lead");

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (option?: string) => {
    if (option) setSelected(option);
    handleSelect(leadId, option);
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        sx={{
          backgroundColor: backgroundColor,
          color: color,
          textTransform: "capitalize",
          borderRadius: "999px",
          fontWeight: 600,
          px: 5,
          py: 0.5,
          fontSize: "12px",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: hoverBackgroundColor,
          },
        }}
        disabled={disabled}
      >
        {isEmployee && (
          <div
            className={styles.agentCardImg}
            style={{
              marginRight: "5px",
            }}
          >
            <Avatar
              alt="avatar"
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                fontSize: "17px",
                background: "#F5F5F7",
                border: "1px solid #EEEEF4",
                color: "#667085",
              }}
            >
              {value?.charAt(0)?.toUpperCase()}
            </Avatar>
          </div>
        )}
        {isPriority && (
          <div>
            <img
              src={
                value === "urgent"
                  ? urgentFlagIcon
                  : value === "high"
                  ? highFlagIcon
                  : value === "normal"
                  ? normalFlagIcon
                  : value === "low"
                  ? lowFlagIcon
                  : defaultFlag
              }
              alt=""
              style={{
                marginRight: "5px",
                marginTop: "6px",
              }}
            />
          </div>
        )}
        {value}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        PaperProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            boxShadow: 2,
            px: 1,
          },
        }}
      >
        {options &&
          options?.map((option: any) => (
            <MenuItem
              key={option?.value}
              onClick={() => handleClose(option)}
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#6c757d",
                borderRadius: 1,
                "&:hover": {
                  backgroundColor: "#f1f1f1",
                },
                textTransform: "capitalize",
              }}
            >
              {option?.label}
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
};

export default PillDropdown;
